<template>
  <div class="processing">
    PROCESSING...
  </div>
</template>

<style scoped>
.processing{
  position: absolute;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: white;
  opacity: 0.8;
}
</style>

<script>
export default {
  name: 'Processing'
}
</script>



// WEBPACK FOOTER //
// src/components/Processing.vue